var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgScrumlrLp09(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 160,
    height: 160,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "A"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "translate(1168 531)",
    fill: "none",
    d: "M0 0h160v160H0z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1168 -531)",
    clipPath: "url(#A)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1215.679 556.811h79.174v73.4c0 6.612.187 6.4 0 17.926-4.2 5.234-26.186 6.36-26.794 6.323l-52.38 2.923z",
    fill: "#5e00ff",
    opacity: 0.715
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1255.266,
    cy: 558.951,
    rx: 39.587,
    ry: 11.769,
    fill: "#c000ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1271.073 602.778v66.501l-60.88 8.134z",
    fill: "#E20360"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1243.279 585.685l27.91 17.234-60.991 74.485-26.996-21.467z",
    fill: "#ff6ba9"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScrumlrLp09);
export default __webpack_public_path__ + "static/media/scrumlr-lp-09.e6522f3f7af99d869b65f5b8b7d49a57.svg";
export { ForwardRef as ReactComponent };